import React, { useState } from "react";
import useUserInfo from "../../../Hooks/useUserInfo";
import { useAudio } from "../../../Providers/AudioProvider";
import matchscedule from "./matchsceduleList";
import { FaCopy, FaShare, FaCheckCircle } from "react-icons/fa";
import { CreateSquadApi } from "../../../apis/iplBattle";
import Swal from "sweetalert2";

function CreateLeague() {
  const { userDetails, updateUserInfo, updatewatchScreenInfo, watchScreen } =
    useUserInfo();
  const playClick = useAudio();
  const [leagueCode, setLeagueCode] = useState("");
  const [leagueName, setLeagueName] = useState("");
  const [isCreated, setIsCreated] = useState(false);
  const [generatedCode, setGeneratedCode] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showManualInput, setShowManualInput] = useState(true);
  const [selectedCollegeName, setSelectedClgName] = useState("");
  const [LeagueType, setLeagueType] = useState("");
  const [LeagueTypeApi, setLeagueTypeApi] = useState("");
  const [promoPoints, setPromoPoints] = useState(500);
  console.log(promoPoints, "promoPoints");

  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: matchscedule,
      currentComponentText: "MatchScheduleList",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };
  const handleSelectLeagueType = (type, type2) => {
    setIsDropdownOpen(false);
    setLeagueType(type);
    setLeagueTypeApi(type2);
  };
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
    setShowManualInput(!isDropdownOpen);
  };
  const [inviteCode, setInviteCode] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Generate a random 6-digit code
    // const code = Math.floor(100000 + Math.random() * 900000).toString();
    // setGeneratedCode(code);
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    var data = {
      squadName: leagueName,
      category: LeagueTypeApi,
      entryFee: LeagueTypeApi == "daily" ? promoPoints : 10000,
    };
    const response = await CreateSquadApi(data);
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: false,
    }));
    if (response?.success) {
      setIsCreated(true);

      setInviteCode(response?.data?.squadCode);
    } else {
      Swal.fire({
        title: "Error!",
        text: response?.error,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);
    // Reset the copied state after 2 seconds
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  const shareLeague = () => {
    playClick();
    const url = encodeURIComponent(
      `https://t.me/the_meme_tv_bot?startapp=${inviteCode}`
    );
    const text = encodeURIComponent(
      "The game's better with the squad. Join me and let's take over!"
    );
    const telegramUrl = `https://t.me/share/url?url=${url}&text=${text}`;

    window.open(telegramUrl, "_blank");
  };
  const getSliderBackground = () => {
    const percentage = ((promoPoints - 500) / (10000 - 500)) * 100;
    return `linear-gradient(to right, 
      #09BD1B 0%, 
      #09BD1B ${percentage}%, 
      #2c2c2c ${percentage}%, 
      #2c2c2c 100%)`;
  };
  return (
    <>
      <div
        className="games_container p-0 w-100"
        style={{ pointerEvents: "fill" }}
      >
        <img
          onClick={() => {
            toogleMenu(matchscedule, "matchscedule");
          }}
          src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
          className="cancel-imgpoints"
          style={{ cursor: "pointer" }}
        />
        <div className="league-container">
          <div className="header-title text-center text-uppercase">
            {isCreated ? "League Created!" : "Create League"}
          </div>
          <div className="league-content">
            {!isCreated ? (
              <form className="p-4">
                <div className="mb-3">
                  <label htmlFor="leagueName" className="form-label text-white">
                    League Name
                  </label>
                  <input
                    type="text"
                    className="form-control text-white "
                    id="leagueName"
                    value={leagueName}
                    onChange={(e) => setLeagueName(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label text-white">League Type</label>
                  <div className="custom-dropdown">
                    <div
                      className={` dropdown-join ${
                        isDropdownOpen ? "active" : ""
                      }`}
                      onClick={toggleDropdown}
                    >
                      <span className="selected-text">
                        {LeagueType || "Choose your league type"}
                      </span>
                      <div className="select-arrow"></div>
                    </div>

                    {isDropdownOpen && (
                      <div className="dropdown-options">
                        <div
                          className="dropdown-item borderjoin"
                          onClick={() =>
                            handleSelectLeagueType("Daily", "daily")
                          }
                        >
                          {"Daily"}
                        </div>
                        <div
                          className="dropdown-item borderjoin"
                          onClick={() =>
                            handleSelectLeagueType("Seasonal", "overallLeague")
                          }
                        >
                          {"Seasonal"}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  {LeagueTypeApi && (
                    <label
                      htmlFor="leagueName"
                      className="form-label text-white"
                    >
                      Entry Fee
                    </label>
                  )}
                  {LeagueTypeApi == "daily" ? (
                    <div className="points-slider-container">
                      {/* <input
                  type="text"
                  className="form-control text-white "
                  id="leagueName"
                  value={promoPoints}
                  disabled={true}
                  required
                /> */}
                      <br></br>
                      <input
                        type="range"
                        min="500"
                        max="10000"
                        step="100"
                        value={promoPoints}
                        onChange={(e) => {
                          const value = parseInt(e.target.value);
                          setPromoPoints(value);
                          e.target.style.background = getSliderBackground();
                        }}
                        style={{ background: getSliderBackground() }}
                        className="points-slider"
                      />
                      <div className="slider-markers">
                        <span>500</span>
                        <span>5000</span>
                        <span>10000</span>
                      </div>
                    </div>
                  ) : LeagueTypeApi == "overallLeague" ? (
                    <input
                      type="text"
                      className="form-control text-white "
                      id="leagueName"
                      value={10000}
                      disabled={true}
                      // onChange={(e) => setLeagueName(e.target.value)}
                      required
                    />
                  ) : (
                    ""
                  )}
                </div>

                <div className="d-grid gap-2 sq-btn-container">
                  <button
                    disabled={!leagueName || !LeagueType}
                    type="submit"
                    className="sq-btn text-uppercase"
                    onClick={handleSubmit}
                  >
                    {LeagueType !== "" ? (
                      <p>
                        {" "}
                        <img
                          style={{
                            width: "25px",
                          }}
                          src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png"
                        />{" "}
                        {LeagueType == "Daily"
                          ? promoPoints
                          : LeagueType == "Seasonal"
                          ? 10000
                          : "Create League"}{" "}
                      </p>
                    ) : (
                      "Create League"
                    )}
                  </button>
                </div>
              </form>
            ) : (
              <div className="success-container p-4 text-center">
                <div className="success-icon mb-4">
                  <FaCheckCircle
                    className="text-success"
                    style={{ fontSize: "60px", color: "#09BD1B" }}
                  />
                </div>

                <h3 className="text-white mb-4 font-size-16">
                  {leagueName} League Created Successfully!
                </h3>

                <div className="divider mb-4"></div>

                <div className="code-container mb-4 ">
                  <div className="d-flex align-items-center justify-content-between code-box">
                    <span className="text-grey">League Code:</span>
                    <div className="d-flex align-items-center gap-2">
                      <span className="text-white code-text">{inviteCode}</span>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between gap-3 px-2">
                  <button
                    className="sq-btn text-uppercase flex-1 d-flex align-items-center justify-content-center gap-2"
                    onClick={shareLeague}
                  >
                    <FaShare /> share
                  </button>
                  <button
                    className="sq-btn text-uppercase flex-1 d-flex align-items-center justify-content-center gap-2"
                    onClick={() => copyToClipboard(inviteCode)}
                  >
                    <FaCopy /> {isCopied ? "Copied" : "Copy"}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <style>
        {`
          .promo-header-container {
            display: flex;
            justify-content: space-between;
            // align-items: center;
            padding:8px 4px;
          }
          .promo-title {
            margin-bottom: 0px;
            color: aliceblue;
            padding: 7px 0px;
          }
          .history-icon {
            cursor: pointer;
            color: #666;
          }

          .history-icon:hover {
            color: #333;
          }

          .create-promo-container {
            padding: 14px;
            // display: flex;
            flex-direction: column;
            gap: 20px;
          }

          .points-slider-container {
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding: 10px 0;
            z-index:0;
            position: relative;
          }

          .points-slider {
            width: 100%;
            height: 8px;
            -webkit-appearance: none;
            background: ${getSliderBackground()};
            // border-radius: 4px;
            outline: none;
            opacity: 1;
            transition: all .2s ease;
          }

          .points-slider::-webkit-slider-runnable-track {
            width: 100%;
            height: 8px;
            cursor: pointer;
            border-radius: 4px;
          }

          .points-slider::-moz-range-track {
            width: 100%;
            height: 8px;
            cursor: pointer;
            border-radius: 4px;
          }

          .points-slider::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 30px;
            height: 20px;
            background: #237E17;
            cursor: pointer;
            box-shadow: 0 0 5px rgba(0,0,0,0.5);
            margin-top: -8px;
            position: relative;
            z-index: 2;
            /* Add horizontal lines using pseudo-elements */
            background-image: linear-gradient(90deg, #03C216, #03C216),
                             linear-gradient(90deg, #03C216, #03C216),
                             linear-gradient(90deg, #03C216, #03C216);
            background-size: 2px 8px;
            background-position: calc(50% - 4px) center,
                        50% center,
                        calc(50% + 4px) center;
            background-repeat: no-repeat;
          }

          .points-slider::-moz-range-thumb {
            width: 30px;
            height: 20px;
            background: #237E17;
            cursor: pointer;
            box-shadow: 0 0 5px rgba(0,0,0,0.5);
            position: relative;
            z-index: 2;
            /* Add horizontal lines using pseudo-elements */
            background-image: linear-gradient(90deg, #03C216, #03C216),
                             linear-gradient(90deg, #03C216, #03C216),
                             linear-gradient(90deg, #03C216, #03C216);
            background-size: 2px 8px;
            background-position: calc(50% - 5px) center,
                        50% center,
                        calc(50% + 4px) center;
            background-repeat: no-repeat;
          }

          .slider-markers {
            display: flex;
            justify-content: space-between;
            padding: 0 2px;
            color: #fff;
            font-size: 12px;
            margin-top: 5px;
          }

          .slider-markers span {
            position: relative;
            text-align: center;
          }

          .slider-markers span:before {
            content: '';
            position: absolute;
            top: -18px;
            width: 2px;
            height: 8px;
            background: #247e17;
          }

          .slider-markers span:first-child:before {
            left: 0;
            right: auto;
            transform: translateX(0);
          }

          .slider-markers span:last-child:before {
            right: 0;
            left: auto;
            transform: translateX(0);
          }

          .slider-markers span:nth-child(2):before {
            left: 50%;
            transform: translateX(-50%);
          }

          .points-slider:hover {
            opacity: 1;
          }

          .mb-3 {
            margin-bottom: 15px;
          }

          .mt-3 {
            margin-top: 15px;
          }

          .btn-rewardsos {
            background: #237E17;
            color: white;
            border: 1px solid #4CF038;
            padding: 10px 20px;
            border-radius: 2px;
            cursor: pointer;
            width: 100%;
            transition: background 0.3s;
          }

          .btn-rewardsos:disabled {
            background: #666;
            cursor: not-allowed;
            opacity: 0.7;
            border: 1px solid #868686;
          }

          .btn-rewardsos:not(:disabled):hover {
            background: #1a5f11;
          }

          .points-input-container {
            position: relative;
            margin-bottom: 15px;
          }

          .points-input-container .coin-icon {
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            width: 20px;
            height: 20px;
          }

          .points-input {
            width: 100%;
            padding: 10px;
            border: 1px solid #6F6F6F;
            border-radius: 2px;
            font-size: 16px;
            color: #237E17;
            background: #1B1B1B;
          }

          .points-input:read-only {
            cursor: default;
          }
            .promo-text
            {
                color: #5b5b5b;
    text-transform: uppercase;
    font-size: 13px;
            }

          .promo-result-input {
               width: 100%;
    padding: 12px 15px;
    border: 1px dashed #515151;
    border-radius: 0px;
    font-size: 16px;
    text-align: center;
    color: #ffffff;
    background: #151515;
    margin-top: 15px;
    margin-bottom: 15px;
    letter-spacing: 1px;
          }

          .button-group {
            display: flex;
            gap: 10px;
            justify-content: center;
            margin-top: 15px;
          }

          .btn-copy, .btn-share {
            padding: 10px;
            border-radius: 2px;
            cursor: pointer;
            transition: all 0.3s;
            display: flex;
            width: 45%;
            text-transform: uppercase;
            align-items: center;
            gap: 8px;
            justify-content: center;
          }

          .button-icon {
            width: 18px;
            height: 18px;
          }

          .btn-copy {
            background: #034807;
            color: #4CF038;
            border: 1px solid #4CF038;
          }

          .btn-share {
            background:rgb(12, 22, 12);
            color: #4CF038;
            border: 1px solid #4CF038;
          }

          .btn-copy:hover, .btn-share:hover {
            opacity: 0.9;
            transform: translateY(-1px);
          }

          .promo-history-link {
            margin-top: 15px;
            cursor: pointer;
            padding: 8px;
            color:#ffffff;
            text-transform: uppercase;
          }

          .history-text {
            color: #ffffff;
            font-size: 14px;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 6px;
            justify-content: center;
          }

          .history-icon {
            width: 20px;
            height: 20px;
            color: #ffffff;
          }

          .history-text:hover {
            opacity: 0.8;
          }
          
          .error-message {
            color: #ff4d4d;
            font-size: 14px;
            text-align: center;
            margin-top: 10px;
            padding: 5px;
            background-color: rgba(255, 77, 77, 0.1);
            border-radius: 4px;
          }
        `}
      </style>
    </>
  );
}

export default CreateLeague;
